module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_intro-tsudoi01-87807dae9f4c781ae6428e05647185ab.jpg";